export default {
    invoiceRecipient: "Rechnungsempfänger",
    contactPerson: "Ansprechperson",
    differentInvoiceRecipient: "Abweichender Rechnungsempfänger",
    differentContactPerson: "Andere Ansprechperson",
    createInvoiceRecipient: "Rechnungsempfänger erfassen",
    createContactPerson: "Ansprechperson erfassen",
    chooseInvoiceRecipient: "Bitte wählen oder legen Sie einen neuen Rechnungsempfänger an:",
    chooseContactPerson: "Bitte geben Sie eine Ansprechperson an:",


    paymentType: "Zahlungsart",
    paymentData: "Zahlungsdaten",
    iban: "IBAN",
    bic: "BIC",
    alternativeAccountHolder: "Abweichender Kontoinhaber",
    paypalData: "PayPal Daten",

    coupon: 'Gutschein',
    redeemCoupon: "Gutschein einlösen",
    couponNumber: "Gutscheinnummer",
    couponCode: "Gutscheincode",
    checkingCoupon: "Überprüfe Code",
    pleaseFillAllFields: "Bitte füllen Sie alle Felder aus um den Gutscheincode einzulösen.",
    invalidCouponCode: "Dieser Gutschein ist nicht gültig. Bitte überprüfen Sie Ihre Eingabe.",
    couponIsIncompatibleWithEvent: "Dieser Gutscheincode kann nicht für diese Veranstaltung verwendet werden.",
    alreadyRedeemedCouponCode: "Dieser Gutscheincode wurde bereits eingelöst.",
    redeemedAmount: "Eingelöster Betrag:",
    remainingAmount: "Restbetrag des Gutscheins:",
    remove: "Entfernen",
    redeemedCoupons: "Bereits eingelöste Gutscheine"
}
